<footer>
  <ul *ngIf="!customPageMode">
    <li>
      <a routerLink="/contract">{{ "footer.contract" | translate }}</a>
    </li>
    <li>
      <a routerLink="/privacy">{{ "footer.privacy" | translate }}</a>
    </li>
  </ul>
  <div *ngIf="customPageMode" class="footer__custom-page">
    <a
      href="https://lingon.io"
      target="_blank"
      class="footer__custom-page__powered"
    >
      <img src="/assets/img/logo.svg" class="footer__logo" alt="Lingon" />
      {{ "footer.poweredByLingon" | translate }}
    </a
    >
    <a class="footer__custom-page__privacy" routerLink="/privacy">{{
        "footer.privacy" | translate
      }}</a>
  </div>
</footer>
